import { render, staticRenderFns } from "./WhatsappConfig.vue?vue&type=template&id=12eacb2a&scoped=true"
import script from "./WhatsappConfig.vue?vue&type=script&lang=js"
export * from "./WhatsappConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eacb2a",
  null
  
)

export default component.exports